<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="addData">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delConfig(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="货物类别配置"
                 width="40%"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="3"/>
                <a-col :span="4">
                    序号：
                </a-col>
                <a-col :span="13">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    货物类别名称：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.name"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    描述：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.descpt"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    备注：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.remark"/>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getTypeQueryList, typeEditDetail, typeDelDetail} from './js/ApiSystem';

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '货物类别名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                visible: false,
                delVisible: false,
                car: [],
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    key: '',
                    value: '',
                    descpt: '',
                    remark: '',
                },
            }
        },
        methods: {
            // 新增按钮
            addData() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                typeEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            // 删除
            delConfig(row) {
                this.lines = row;
                this.delVisible = true;
            },
            delOk() {
                this.delVisible = false;
                typeDelDetail({id: this.lines.id}).then(() => {
                    this.getData();
                });
            },
            cancel() {
                this.delVisible = false;
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getTypeQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    key: '',
                    value: '',
                    descpt: '',
                    remark: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                this.getData({baseDto: baseDto});
            },
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }
</style>
